<template>
  <div class="container">
    <carousel :autoplay="4000" :wrap-around="true">
      <slide v-for="slide in slides" :key="slide">
          <img :src="slide.url" :alt="slide.alt" width="500" height="400">
      </slide>
 
      <template #addons>
        <navigation />
      </template>
    </carousel>
  </div>
</template>
 
<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Navigation, Slide } from "vue3-carousel";
 
export default {
  name: "Crousel",
  props: ['slides'],
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
<style lang='scss'>
.container {
  margin: 0 auto;
  max-width: 500px;
//   width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  .carousel {
      width: 100%;
  }
}
.carousel__slide {
  padding: 10px;
  min-height: 200px;
  width: 100%;
//   background-color: #642afb;
  display: flex;
  justify-content: center;
  align-items: center;
}
 
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    background: transparent;
    width: 38px;
    height: 38px;
    border-style: solid;
    border-radius: 0;
    svg {
        display: none;
    }
}
$border-color: #4376A2;
.carousel__prev {
    border-color: $border-color transparent transparent $border-color;
    border-width: 3px 0 0 3px;
    transform: rotate(-45deg) translateY(-50%);
    left: 36px;
}
.carousel__next {
    border-color: $border-color $border-color transparent transparent;
    border-width: 3px 3px 0 0;
    transform: rotate(45deg) translateY(-50%);
    right: 36px;
}
</style>